import { render, staticRenderFns } from "./WfConsumerCorpCustomerModal.vue?vue&type=template&id=e458df58&"
import script from "./WfConsumerCorpCustomerModal.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports